import { createFileRoute } from "@tanstack/react-router";
import { loadHeroIsoArtwork } from "src/components/landing/HeroIso/HeroIsoArtworkLoader";
import { metadataHead } from "src/lib/Metadata";
import { LANDING_METADATA } from "src/lib/Seo";
import { getHomePage } from "src/server/functions/HomePage";

// The landing page, or the waitlist sign-up while the waitlist is on (src/server/functions/HomePage.tsx).
export const Route = createFileRoute("/")({
  // Both pages show the hero; a client-side navigation loads its artwork with the page.
  loader: async () => {
    const [page] = await Promise.all([
      getHomePage(),
      import.meta.env.SSR ? undefined : loadHeroIsoArtwork(),
    ]);
    return page;
  },
  head: () => metadataHead(LANDING_METADATA),
  component: () => <>{Route.useLoaderData().content}</>,
});
